import { createSlice } from '@reduxjs/toolkit';

const initialState = { widgetId: '' };

const fielSlice = createSlice({
  name: 'slice',
  initialState,
  reducers: {
    addWidgetId: (state, action) => {
      state.widgetId = action.payload;
    },
    removeWidgetId: (state, action) => {
      state.widgetId = '';
    }
  }
});

export const { addWidgetId, removeWidgetId } = fielSlice.actions;
export default fielSlice.reducer;
